(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rivo-potential-points"] && !Shopify.designMode) return;
  try {
    var noPointsText = document.querySelector('.rivo-container-points').getAttribute('data-no-points-text');

function getUSDValue(localValue) {
  if (window.Shopify && window.Shopify.currency) {
    var rate = window.Shopify.currency.rate;
    // Replace comma with dot for decimal, remove all but digits and dot
    var normalized = localValue.replace(',', '.').replace(/[^0-9.]/g, '');
    var numericValue = Number(normalized);
    return numericValue / rate;
  }
  return Number(localValue.replace(',', '.').replace(/[^0-9.]/g, ''));
}

function updatePotentialPoints(dataValue) {
  var balanceAmount = Number(document.querySelector('.rivo-container-points').getAttribute('data-balance-amount')) || 1;
  var usdValue = getUSDValue(dataValue);
  var roundedValue = Math.ceil(usdValue);
  var points = roundedValue * balanceAmount;
  var pointsSpan = document.getElementById('rivo-points-value');

  if (isNaN(points) || !isFinite(points) || points === 0) {
    // Hide the points text
    var pointsText = document.querySelector('.rivo-points-text');
    if (pointsText) pointsText.style.display = 'none';
    // Remove any previous .rivo-sentence
    var prevSentence = document.querySelector('.rivo-sentence');
    if (prevSentence && prevSentence.parentNode) prevSentence.parentNode.removeChild(prevSentence);
    // Add a new sentence
    var container = document.querySelector('.rivo-potential-text');
    if (container) {
      var p = document.createElement('p');
      p.className = 'rivo-sentence';
      p.textContent = noPointsText || '';
      container.appendChild(p);
    }
  } else {
    // Show the points text
    var pointsText = document.querySelector('.rivo-points-text');
    if (pointsText) pointsText.style.display = '';
    // Remove any previous .rivo-sentence
    var prevSentence = document.querySelector('.rivo-sentence');
    if (prevSentence && prevSentence.parentNode) prevSentence.parentNode.removeChild(prevSentence);
    if (pointsSpan) pointsSpan.textContent = points;
  }
  var potentialText = document.querySelector('.rivo-container-points');
  if (potentialText) potentialText.style.display = '';
  return points;
}

document.addEventListener('DOMContentLoaded', function() {
  var deliveryInputs = document.querySelectorAll('[name="delivery"]');
  // Get the default checked input on load
  var checkedInput = document.querySelector('[name="delivery"]:checked');
  if (checkedInput) {
    var defaultValue = checkedInput.getAttribute('data-value-points');
    var pointsDefault = updatePotentialPoints(defaultValue);
  }
  deliveryInputs.forEach(function(input) {
    input.addEventListener('click', function() {
      var dataValue = input.getAttribute('data-value-points');
      var points = updatePotentialPoints(dataValue);
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
